import React from "react";
import Marquee from "react-fast-marquee";

export const Ribbon = ({ text }) => {
  const repeated = `${text} ${text} ${text}`;
  return (
    <div
      data-testid="ribbon-marquee"
      className="border-y border-[#3A342E] py-6 bg-[#110F0E]"
    >
      <Marquee gradient={false} speed={36} pauseOnHover>
        <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#9D9287] px-6">
          {repeated}
        </span>
      </Marquee>
    </div>
  );
};
